export { default } from "./fastBuy";
